import React from 'react';
import { Grid, Card, CardContent, Typography } from '@deere/fuel-react';
import {QUALITY_PEER_GROUP, SET_UP_QBIC} from "../shared/Constants";

export const SupplierQbicCard = ({supplierData}) => {
    return (
        <Grid item xs={12}>
            <Card>
                <CardContent style={{ minHeight: '6rem' }}>
                    <Grid container alignItems="flex-start" spacing={2}>
                        <Grid item xs={12} md={6}>
                            <Typography variant="label">{SET_UP_QBIC}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="label">{QUALITY_PEER_GROUP}</Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body1">
                                {supplierData.qualityPeerGroup !== "" ? "Yes" : "No"}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Typography variant="body1">
                                {supplierData.qualityPeerGroup !== "" ? supplierData.qualityPeerGroup : "-"}
                            </Typography>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Grid>
    );
}